<template>
<div class="login-container-0">
<div class="login-container-1">

	<el-card class="login-card">
		
		<el-row :gutter="80">
			
			<el-col :span="12" class="hidden-xs-only col-logo">
				<logo />
			</el-col>
			
			<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="col-content">
				<div class="hidden-sm-and-up">
					<logo size="medium"/>
				</div>

				<slot/>

			</el-col>

		</el-row>
		
	</el-card>

</div>
</div>
</template>

<script>
import Logo from '@/components/logo.component'

export default {
	name: 'LoginLayout',
	components: { Logo },
}
</script>

<style>
.login-container-0 {
	width: 100%;
	margin: 0 auto;
}

.login-container-1 {
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	background: linear-gradient(-135deg,#b3ffff,#00ace6);
}

.login-card {
	width: 960px;
	text-align: center;
	margin: 15px;
	padding-top: 80px;
	padding-bottom: 50px;
}

.col-logo {
	padding-bottom: 40px;
	padding-top: 40px;
	border-right: 1px solid #d9e6f2;
}

.col-content {
	border-left: 1px solid #d9e6f2;
	margin-left: -1px;
}


@media only screen and (max-width:767px) {
	.login-card {
		padding-top: 10px;
	}
}

</style>